import { useAppSelector } from '../../../reducers';
import { isUngatedForCheckoutInterstitialUISelector } from '../../../selectors/GatingSelectors';
import useIsEligibleForFreeToProTouchlessFlow from '../../interstitial/hooks/useIsEligibleForFreeToProTouchlessFlow';
import { productForSkuIdSelector, skuIdIsHubSelector } from '../../../selectors/ProductsSelectors';
const FREE_TO_PRO = 'free-to-pro';
const useIsEligibleForCheckoutInterstitialUI = productConfigurations => {
  let targetFlow = null;
  const isUngatedForCheckoutInterstitialUI = useAppSelector(isUngatedForCheckoutInterstitialUISelector);
  const isEligibleForFreeToProTouchlessFlow = useIsEligibleForFreeToProTouchlessFlow(productConfigurations);
  targetFlow = isEligibleForFreeToProTouchlessFlow ? FREE_TO_PRO : null;
  const productHasQuantityPacks = useAppSelector(state => {
    const hubProductConfigs = productConfigurations.filter(config => skuIdIsHubSelector(state, {
      skuId: config.skuId
    }));
    const hubProductConfig = hubProductConfigs[0];
    if (!hubProductConfig) {
      return false;
    }
    const product = productForSkuIdSelector(state, {
      skuId: hubProductConfig === null || hubProductConfig === void 0 ? void 0 : hubProductConfig.skuId
    });
    return product.currentVersion.quantityPackDetails.length > 0;
  });
  return {
    isEligibleForCheckoutInterstitialUI: isUngatedForCheckoutInterstitialUI && !productHasQuantityPacks,
    targetFlow
  };
};
export default useIsEligibleForCheckoutInterstitialUI;